import { makeStyles, withStyles } from '@material-ui/core/styles';
import StepConnector from '@material-ui/core/StepConnector';

export const ColorLibConnector = withStyles({
    alternativeLabel: {
        top: 15,
    },
    active: {
        '& $line': {
            backgroundColor: '#454545',
        },
    },
    completed: {
        '& $line': {
            backgroundColor: '#454545',
        },
    },
    disabled: {
        '& $line': {
            backgroundColor: '#ccc',
        },
    },
    line: {
        height: 3,
        border: 0,
        backgroundColor: '#eaeaf0',
        borderRadius: 1,
    },
})(StepConnector);

export const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    button: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    stepButton: {
        outline: 'none'
    }
}));

